import React from 'react';
import nodata from '../Images/nodata.jpg';

function NoData() {
  const inlineStyle = {
    imgContainer: {
      width: '50%',
      aspectRatio: '1/1', 
      backgroundColor: '#FFFFFF', 
     
    },
    imgMainContainer: {
      width: '100%',
      paddingBlock: '10px', 
      display: 'flex',
      justifyContent: 'center', 
    },
    nodataImgContainer: {
      width: '100%',
      height: '100%',
    },
  };

  return (
    <div style={inlineStyle.imgMainContainer}>
      <div style={inlineStyle.imgContainer}>
        <img style={inlineStyle.nodataImgContainer} src={nodata} alt="NoData" />
      </div>
    </div>
  );
}

export default NoData;
